import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  public silence = environment.production && !environment.enableDebugLogs;

  log(...args: any[]) {
    if (!this.silence) {
      console.log(...args);
    }
  }

  warn(...args: any[]) {
    if (!this.silence) {
      console.warn(...args);
    }
  }

  error(...args: any[]) {
    if (!this.silence) {
      console.error(...args);
    }
  }
}
